import React, { createContext, useCallback, useContext,useState } from 'react';
import { CompanyState } from '../types/stateProviders/CompanyState';

const CompanyStateContext = createContext<any | null>(null);
const CompanyDispatchContext = createContext<(newState:Partial<CompanyState>) => void>(() => {});

export const CompanyStateProvider:React.FC<{children:React.ReactNode}> = ({ children }) => {

  const initialCompanyState:CompanyState = {
    additionalCosts: [],
    logisticCosts: null,
  }

  const [companyState, setCompanyState] = useState<CompanyState>(initialCompanyState)
  const updateCompanyState = useCallback((newCompanyState:Partial<CompanyState>) => {
    setCompanyState( (prevState:CompanyState) => {
        return {...prevState, ...newCompanyState}
    })
  },[])

  return (
    <CompanyStateContext.Provider value={companyState}>
      <CompanyDispatchContext.Provider value={updateCompanyState}>
        {children}
      </CompanyDispatchContext.Provider>
    </CompanyStateContext.Provider>
  );
}

export function useCompanyState():CompanyState {
  return useContext(CompanyStateContext);
}

export function useCompanyDispatch():React.Dispatch<Partial<CompanyState>>{
  return useContext(CompanyDispatchContext);
}